<template>
  <div class="delivery-code-wrapper">
    <!--  FoodB_0526_CJIS_cGuT: 店铺配送 -->
    <mobile-header :title="$t('FoodB_0526_CJIS_cGuT')" />
    <div class="page-container">
      <!-- 进度条 -->
      <progress-steps
        :steps="[
          $t('FoodB_0526_obJO_XULq', { number1: 1 }), // FoodB_0526_obJO_XULq 步骤{{number1}}
          $t('FoodB_0526_BiXD_Hdyk', { number2: 2 }), // FoodB_0526_BiXD_Hdyk 步骤{{number2}}
        ]"
        :current-step="1"
      />

      <!-- 引导说明 -->
      <div class="guide-section">
        <!-- FoodB_0526_xxjK_BrKm 验证客户确认码 -->
        <div class="guide-title">{{ $t('FoodB_0526_xxjK_BrKm') }}</div>
        <!-- FoodB_0526_CWJT_tJDS 当你与顾客见面并把食物交接他们时，请他们提供4位数字的验证码，以确认送达。 -->
        <div class="guide-text">{{ $t('FoodB_0526_CWJT_tJDS', { number4: 4 }) }}</div>
      </div>

      <!-- 输入框 -->
      <div class="input-section">
        <verification-code-input
          v-model="deliveryCode"
          :has-error="deliveryCodeError"
          :length="4"
          @change="handleInput"
        />
      </div>

      <!-- 按钮 -->
      <div class="action-buttons">
        <go-button :disabled="!isValidCode" :loading="loading" @click="handleVerify">
          <!-- FoodB_0526_ZwcV_xubO 完成配送 -->
          {{ $t('FoodB_0526_ZwcV_xubO') }}
        </go-button>
        <go-button type="secondary" @click="handleBack">
          <!-- FoodB_0526_pago_jZCL 返回 -->
          {{ $t('FoodB_0526_pago_jZCL') }}
        </go-button>
      </div>
    </div>
  </div>
</template>

<script>
import { completeOrder } from './api'
import VerificationCodeInput from '@/components/verification-code-input'
import ProgressSteps from '@/components/progress-steps'
import Track from '@/utils/track'
import MobileHeader from '@/components/mobile-header'

export default {
  name: 'DeliveryCode',
  components: {
    VerificationCodeInput,
    ProgressSteps,
    MobileHeader,
  },
  data() {
    return {
      orderId: '',
      locator: '',
      deliveryCode: '',
      isValidCode: false,
      deliveryCodeError: false,
      loading: false,
    }
  },
  watch: {
    deliveryCode(value) {
      this.deliveryCodeError = false
    },
  },
  created() {
    const { orderId, locator, shopId } = this.$route.query
    this.orderId = orderId
    this.locator = locator
    this.shopId = shopId
  },
  methods: {
    handleInput(value) {
      this.isValidCode = value.length === 4
    },
    async handleVerify() {
      if (!this.isValidCode) return

      try {
        this.loading = true
        const res = await completeOrder({
          orderId: this.orderId,
          DCPickupCode: this.deliveryCode,
          locator: this.locator,
        })
        this.loading = false
        if (res?.data?.code === 1) {
          Track.deliveringCompleteTheDeliveryClick({
            shop_id: this.shopId,
            order_id: this.orderId,
          })
          // 验证成功，跳转到完成页面
          this.$router.push({
            path: '/confirmation-entrega/completed',
            query: {
              orderId: this.orderId,
              shopId: this.shopId,
            },
          })
        } else {
          this.deliveryCodeError = true
          // 验证失败
          this.$createGoToast({
            // FoodB_0526_wOWe_bCYw 输入的客户确认码未识别，请重试。
            text: res?.data?.msg || this.$t('FoodB_0526_wOWe_bCYw'),
          }).show()
        }
      } catch (error) {
        this.loading = false
        this.$createGoToast({
          // FoodB_0526_wOWe_bCYw 输入的客户确认码未识别，请重试。
          text: this.$t('FoodB_0526_wOWe_bCYw'),
        }).show()
      }
    },
    handleBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.delivery-code-wrapper {
  background-color: #fff;
  text-align: center;

  .page-container {
    margin: 0 auto;
    max-width: 750px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .guide-section {
    .guide-title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 48px;
      color: #0b0b0d;
      letter-spacing: 0;
      text-align: center;
      line-height: 56px;
      font-weight: 700;
      margin-bottom: 32px;
    }

    .guide-text {
      font-family: DiDiSans-Pro-Regular;
      font-size: 32px;
      color: #0b0b0d;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      margin-bottom: 120px;
    }
  }

  .input-section {
    margin-bottom: 120px;
  }

  .action-buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .go-button {
      flex: 0 0 auto;
      min-width: 200px;
    }
  }

  @media (min-width: 750px) {
    .action-buttons {
      flex-direction: row-reverse;
      gap: 32px;
      justify-content: center;
    }
  }
}
</style>
